import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Pending Batch Activities")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top 5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "mt-5" }
const _hoisted_8 = { class: "card p-3 position-relative" }
const _hoisted_9 = { class: "row m-0" }
const _hoisted_10 = { class: "col bg-light-success d-flex align-items-center px-3 py-8 rounded-2 me-4" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book fs-2x text-success" })
], -1)
const _hoisted_13 = { class: "col mt-3" }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-success fw-bold fs-7 mt-2" }, " Enrollment Pending ", -1)
const _hoisted_16 = { class: "col bg-light-primary d-flex align-items-center px-3 py-8 rounded-2 me-4" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "d-block my-2 col-md-3 mr-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clock fs-2x text-primary" })
], -1)
const _hoisted_19 = { class: "col mt-3" }
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary fw-bold fs-7 mt-2" }, " Attendance Pending ", -1)
const _hoisted_22 = { class: "col bg-light-info d-flex align-items-center px-1 py-8 rounded-2 me-4" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-info d-block my-2 col-md-3 mx-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle fs-2x text-info" })
], -1)
const _hoisted_25 = { class: "col mt-3" }
const _hoisted_26 = ["href"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "text-info fw-bold fs-7 mt-2" }, " Assessment Pending ", -1)
const _hoisted_28 = { class: "col bg-light-danger d-flex align-items-center px-3 py-8 rounded-2 me-4" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-danger d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-certificate fs-2x text-danger" })
], -1)
const _hoisted_31 = { class: "col mt-3" }
const _hoisted_32 = ["href"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "text-danger fw-bold fs-7 mt-2" }, " Certification Pending ", -1)
const _hoisted_34 = { class: "col bg-light-warning d-flex align-items-center px-3 py-8 rounded-2 me-4" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3x svg-icon-warning d-block my-2 col-md-3 mr-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-tie fs-2x text-warning" })
], -1)
const _hoisted_37 = { class: "col mt-3" }
const _hoisted_38 = ["href"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "text-warning fw-bold fs-7 mt-2" }, " Employment Pending ", -1)
const _hoisted_40 = { class: "card mb-5 mt-7" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, null, -1)
const _hoisted_42 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_43 = { class: "collapse show" }
const _hoisted_44 = { class: "card-body border-top p-9" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", {
  class: "current",
  "data-kt-stepper-element": "content"
}, null, -1)
const _hoisted_46 = { class: "table-responsive mt-5" }
const _hoisted_47 = { class: "table table-borderless gy-4" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", null, "Training Partner"),
    /*#__PURE__*/_createElementVNode("th", null, "Enrollment Pending"),
    /*#__PURE__*/_createElementVNode("th", null, "Attendance Pending"),
    /*#__PURE__*/_createElementVNode("th", null, "Assessment Pending"),
    /*#__PURE__*/_createElementVNode("th", null, "Certification Pending"),
    /*#__PURE__*/_createElementVNode("th", null, "Employment < 60%")
  ])
], -1)
const _hoisted_49 = { style: {} }
const _hoisted_50 = { class: "align-middle" }
const _hoisted_51 = { class: "align-middle" }
const _hoisted_52 = { class: "align-middle" }
const _hoisted_53 = { class: "align-middle" }
const _hoisted_54 = { class: "align-middle" }
const _hoisted_55 = { class: "align-middle" }
const _hoisted_56 = { class: "align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives((_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("h5", _hoisted_13, [
                          _createElementVNode("a", {
                            href: `${this.VUE_APP_TMS}/pending-activity-summary/` +
                                      1
                                      ,
                            target: "_blank",
                            class: "text-primary"
                          }, _toDisplayString(Number(_ctx.totalPendingEnrollment).toLocaleString()), 9, _hoisted_14)
                        ]),
                        _hoisted_15
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("h5", _hoisted_19, [
                          _createElementVNode("a", {
                            href: `${this.VUE_APP_TMS}/pending-activity-summary/` +
                                        2
                                        ,
                            target: "_blank",
                            class: "text-primary"
                          }, _toDisplayString(Number(_ctx.totalPendingAttendace).toLocaleString()), 9, _hoisted_20)
                        ]),
                        _hoisted_21
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("h5", _hoisted_25, [
                          _createElementVNode("a", {
                            href: `${this.VUE_APP_TMS}/pending-activity-summary/` +
                                          3
                                          ,
                            target: "_blank",
                            class: "text-primary"
                          }, _toDisplayString(Number(_ctx.totalPendingAssessment).toLocaleString()), 9, _hoisted_26)
                        ]),
                        _hoisted_27
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("h5", _hoisted_31, [
                          _createElementVNode("a", {
                            href: `${this.VUE_APP_TMS}/pending-activity-summary/` +
                                            4
                                            ,
                            target: "_blank",
                            class: "text-primary"
                          }, _toDisplayString(Number(_ctx.totalPendingCertification).toLocaleString()), 9, _hoisted_32)
                        ]),
                        _hoisted_33
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createElementVNode("h5", _hoisted_37, [
                          _createElementVNode("a", {
                            href: `${this.VUE_APP_TMS}/pending-activity-summary/` +
                                            5
                                            ,
                            target: "_blank",
                            class: "text-primary"
                          }, _toDisplayString(Number(_ctx.totalPendingEmployment).toLocaleString()), 9, _hoisted_38)
                        ]),
                        _hoisted_39
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _hoisted_45,
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("table", _hoisted_47, [
                              _hoisted_48,
                              _createElementVNode("tbody", _hoisted_49, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associationDataCount, (data, index) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: index,
                                    style: {"border-bottom":"1px solid\r\n                                        rgba(29, 182, 140, 0.51)"}
                                  }, [
                                    _createElementVNode("td", _hoisted_50, _toDisplayString(index + 1), 1),
                                    _createElementVNode("td", _hoisted_51, " [" + _toDisplayString(data?.entity_info?.entity_short_name) + "]-" + _toDisplayString(data?.entity_info?.entity_name), 1),
                                    _createElementVNode("td", _hoisted_52, _toDisplayString(data?.enrollment_pending), 1),
                                    _createElementVNode("td", _hoisted_53, _toDisplayString(data?.attendance_pending), 1),
                                    _createElementVNode("td", _hoisted_54, _toDisplayString(data?.assessment_pending), 1),
                                    _createElementVNode("td", _hoisted_55, _toDisplayString(data?.certification_pending), 1),
                                    _createElementVNode("td", _hoisted_56, _toDisplayString(data?.employment_pending), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.load]
            ])
          ])
        ])
      ])
    ])
  ]))
}